import React from "react";
import { LogOut } from "lucide-react";
import { NavLink } from "react-router-dom";

const adminLinks = [
  { label: "Newsletters", href: "/admin/newsletter" },
  { label: "Blogs", href: "/admin/blog" },
  { label: "Case Studies", href: "/admin/case-studies" },
];

const AdminSectionNav = ({ admin, onLogout }) => {
  return (
    <div className="mt-4 flex flex-wrap items-center gap-2">
      {adminLinks.map((link) => (
        <NavLink
          key={link.href}
          to={link.href}
          className={({ isActive }) =>
            `rounded border px-3 py-2 text-sm transition ${
              isActive
                ? "border-gray-900 bg-gray-900 text-white"
                : "border-gray-300 bg-white text-gray-700 hover:bg-gray-100"
            }`
          }
        >
          {link.label}
        </NavLink>
      ))}
      {admin ? (
        <div className="rounded border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700">
          Signed in as {admin.name}
        </div>
      ) : null}
      {onLogout ? (
        <button
          type="button"
          onClick={onLogout}
          className="inline-flex items-center gap-2 rounded border border-red-300 bg-red-50 px-3 py-2 text-sm font-medium text-red-700 transition hover:bg-red-100"
        >
          <LogOut className="h-4 w-4" />
          Logout
        </button>
      ) : null}
    </div>
  );
};

export default AdminSectionNav;
